/* @format */
import moment from 'moment';

const lowerCaseFirstCharacter = (value) => value.charAt(0).toLowerCase() + value.slice(1);

export const EXIT_SURVEY_RESPONSE_TYPE = {
    DIDNT_USE_ENOUGH: 'DidntUseEnough',
    MISSING_FEATURES: 'MissingFeatures',
    TOO_DIFFICULT: 'TooDifficult',
    TOO_EXPENSIVE: 'TooExpensive',
    TECHNICAL_ISSUES: 'TechnicalIssues',
    MOVING_SOLUTIONS: 'MovingSolutions',
    OTHER: 'Other',
};

export const EXIT_SURVEY_RESPONSE_TYPE_KEY = {
    DIDNT_USE_ENOUGH: lowerCaseFirstCharacter(EXIT_SURVEY_RESPONSE_TYPE.DIDNT_USE_ENOUGH),
    MISSING_FEATURES: lowerCaseFirstCharacter(EXIT_SURVEY_RESPONSE_TYPE.MISSING_FEATURES),
    TOO_DIFFICULT: lowerCaseFirstCharacter(EXIT_SURVEY_RESPONSE_TYPE.TOO_DIFFICULT),
    TOO_EXPENSIVE: lowerCaseFirstCharacter(EXIT_SURVEY_RESPONSE_TYPE.TOO_EXPENSIVE),
    TECHNICAL_ISSUES: lowerCaseFirstCharacter(EXIT_SURVEY_RESPONSE_TYPE.TECHNICAL_ISSUES),
    MOVING_SOLUTIONS: lowerCaseFirstCharacter(EXIT_SURVEY_RESPONSE_TYPE.MOVING_SOLUTIONS),
    OTHER: lowerCaseFirstCharacter(EXIT_SURVEY_RESPONSE_TYPE.OTHER),
};

export const EXIT_SURVEY_RESPONSE_LABEL = {
    DIDNT_USE_ENOUGH: "Didn't use GlassHive enough",
    MISSING_FEATURES: "We need features that GlassHive doesn't have",
    TOO_DIFFICULT: 'GlassHive was too difficult to use',
    TOO_EXPENSIVE: 'Too expensive',
    TECHNICAL_ISSUES: 'Technical issues',
    MOVING_SOLUTIONS: "We're moving to a different solution",
    OTHER: 'Other',
};

export const EXIT_SURVEY_TYPE_LABEL_MAP = {
    [EXIT_SURVEY_RESPONSE_TYPE.DIDNT_USE_ENOUGH]: EXIT_SURVEY_RESPONSE_LABEL.DIDNT_USE_ENOUGH,
    [EXIT_SURVEY_RESPONSE_TYPE.MISSING_FEATURES]: EXIT_SURVEY_RESPONSE_LABEL.MISSING_FEATURES,
    [EXIT_SURVEY_RESPONSE_TYPE.TOO_DIFFICULT]: EXIT_SURVEY_RESPONSE_LABEL.TOO_DIFFICULT,
    [EXIT_SURVEY_RESPONSE_TYPE.TOO_EXPENSIVE]: EXIT_SURVEY_RESPONSE_LABEL.TOO_EXPENSIVE,
    [EXIT_SURVEY_RESPONSE_TYPE.TECHNICAL_ISSUES]: EXIT_SURVEY_RESPONSE_LABEL.TECHNICAL_ISSUES,
    [EXIT_SURVEY_RESPONSE_TYPE.MOVING_SOLUTIONS]: EXIT_SURVEY_RESPONSE_LABEL.MOVING_SOLUTIONS,
    [EXIT_SURVEY_RESPONSE_TYPE.OTHER]: EXIT_SURVEY_RESPONSE_LABEL.OTHER,
};

export function getCorrectedExitSurveyBillingEndDate(date) {
    return moment.utc(date).local(true).add(1, 'd');
}
